// extracted by mini-css-extract-plugin
export var readonly = "_hn-1";
export var star = "_hn-0";